import { render } from "./AllTruckUpdates.vue?vue&type=template&id=fc18ec66&scoped=true"
import script from "./AllTruckUpdates.vue?vue&type=script&lang=js"
export * from "./AllTruckUpdates.vue?vue&type=script&lang=js"

import "./AllTruckUpdates.vue?vue&type=style&index=0&id=fc18ec66&lang=scss&scoped=true"

import exportComponent from "/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fc18ec66"]])

export default __exports__